module.exports = "<p>\r\n  awsop-lab11 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab11/awsop-lab11.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab11/awsop-lab11.component.html
// module chunks = main